import { inject } from "@angular/core";
import { LazyInject } from "../services/lazy-inject.service";
import {
  type ISaveUndoChanges,
  type PendingChangesService,
} from "../services/pending-changes.service";
import NProgress from "../ts/nprogress-customizations";

export async function PendingChangesGuard(
  component: ISaveUndoChanges | object,
) {
  const lazyInjector = inject(LazyInject);
  const pendingChangesService = await lazyInjector.get<PendingChangesService>(
    import("../services/pending-changes.service").then(
      (m) => m.PendingChangesService,
    ),
  );

  // Pause progress while the modal is up
  NProgress.done();
  const canDeactivate = await pendingChangesService.canDeactivate(component);
  if (canDeactivate) {
    // If we can deactivate, start progress again
    NProgress.start();
  }

  return canDeactivate;
}
